import { THEMES, FONTS, getTheme } from '@makerstack/page-render'

export function StyleTab({
  theme,
  font,
  onThemeChange,
  onFontChange,
}: {
  theme: string
  font: string
  onThemeChange: (id: string) => void
  onFontChange: (id: string) => void
}) {
  return (
    <div className="space-y-8">
      <section>
        <h3 className="mb-3 text-xs font-semibold uppercase tracking-wide text-zinc-500">Font</h3>
        <div className="grid grid-cols-3 gap-2">
          {FONTS.map((f) => (
            <button
              key={f.id}
              onClick={() => onFontChange(f.id)}
              style={{ fontFamily: f.stack }}
              className={`rounded-lg border px-3 py-3 text-sm ${
                font === f.id
                  ? 'border-fuchsia-500 bg-fuchsia-500/10 text-white'
                  : 'border-zinc-800 bg-zinc-900 text-zinc-300 hover:border-zinc-700'
              }`}
            >
              {f.name}
            </button>
          ))}
        </div>
      </section>

      <section>
        <h3 className="mb-3 text-xs font-semibold uppercase tracking-wide text-zinc-500">Theme</h3>
        <div className="grid grid-cols-4 gap-2 sm:grid-cols-5">
          {THEMES.map((t) => {
            const k = getTheme(t.id).tokens
            const selected = theme === t.id
            return (
              <button
                key={t.id}
                onClick={() => onThemeChange(t.id)}
                title={t.name}
                className={`flex h-14 overflow-hidden rounded-lg border-2 ${
                  selected ? 'border-fuchsia-500' : 'border-transparent hover:border-zinc-700'
                }`}
              >
                <span className="flex-1" style={{ background: k.pageBg }} />
                <span className="flex-1" style={{ background: k.accent }} />
              </button>
            )
          })}
        </div>
      </section>
    </div>
  )
}
